import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Back / forward browser-history buttons. Renders as a small pill group. */
export default function NavArrows({ className = "" }) {
  const navigate = useNavigate();
  return (
    <div className={`inline-flex rounded-md border border-white/10 overflow-hidden ${className}`}>
      <button
        data-testid="btn-nav-back"
        onClick={() => navigate(-1)}
        aria-label="Back"
        className="p-1.5 text-stone-400 hover:bg-white/5 hover:text-stone-100 transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      <div className="w-px bg-white/10" />
      <button
        data-testid="btn-nav-forward"
        onClick={() => navigate(1)}
        aria-label="Forward"
        className="p-1.5 text-stone-400 hover:bg-white/5 hover:text-stone-100 transition-colors"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}
